import React from 'react';
import { useSelector } from 'react-redux';
import {
	CButton,
	CModal,CModalBody,CModalFooter,CModalHeader,
	CModalTitle, CCloseButton,
	CLink,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { MyButton } from './index';
import { UFunc } from "../helpers/functions";
import PropTypes from 'prop-types';

const MyDialogformFs = props => {	
	const {
		show,
		toggle,
		renderContent,
		dialogHeader,
		onSimpan,
		options,
		...rest
	} = props;
	
	const uBahasaObj  = useSelector(state => state.listBahasa);

	return (
		<CModal
			fullscreen={true} 
			visible={show}
			scrollable
			{...rest}>
		<CModalHeader closeButton={false} style={{zIndex:1}}
			className="justify-content-start align-items-center classheadertop">
			<CLink onClick={toggle} className="classcursorpointer">
			<CIcon icon="cilArrowCircleLeft" className="me-2 text-black align-top" height={30}/>
			</CLink>

			<CModalTitle className="">
			<small className="fw-bolder">{UFunc.renderHTML(dialogHeader||MyDialogformFs.defaultProps.dialogHeader)}</small>
			</CModalTitle>
		</CModalHeader>

		<CModalBody style={{
			zIndex:1,
			backgroundColor:(options||{}).hasOwnProperty("bgColor")?options.bgColor:MyDialogformFs.defaultProps.options.bgColor,
			}}>
			{renderContent}
		</CModalBody>

		<CModalFooter>
		<MyButton
			onClick={()=>onSimpan()}
			id="btnDialogSimpan">
			<CIcon icon="cilCheckAlt" 
			 	className="me-1 classverticalmiddle"
				height={20}/>
			{uBahasaObj.word_ok||"OK !"}
		</MyButton>
		<span className="me-1"/>
		<CButton color="light" onClick={toggle}>{uBahasaObj.word_batal||"Batal"}</CButton>
		</CModalFooter>
		</CModal>
	)//>
}
MyDialogformFs.defaultProps = {
	show: false,
	renderContent: "{UNDEFINED}..",
	dialogHeader: "Form Data",
	options: {bgColor:"transparent", init_bgimage: "YA"}
};
MyDialogformFs.propTypes = {
	show: PropTypes.bool,            
	toggle: PropTypes.func,      
	renderContent: PropTypes.element, 
	dialogHeader: PropTypes.string,
	onSimpan: PropTypes.func,
	options: PropTypes.object,
}

export default MyDialogformFs;